import { http } from "@/communication";
import moment from "moment";

const ping = {
  namespaced: true,
  state: {
    pings: [],
    start: null,
    timeouts: {
      getPings: null,
      saveStatistic: null
    }
  },
  actions: {
    start({ commit, dispatch }) {
      let timeouts = {};
      dispatch("makePing");
      timeouts.getPings = window.setInterval(() => {
        dispatch("makePing");
      }, 1000 * Laravel.config.make_ping_delay);
      timeouts.saveStatistic = window.setInterval(() => {
        dispatch("saveStatistic");
      }, 60000 * Laravel.config.save_ping_delay);
      commit("setTimeout", timeouts);
    },
    stop({ commit, state, dispatch }) {
      window.clearInterval(state.timeouts.getPings);
      window.clearInterval(state.timeouts.saveStatistic);
      commit("setTimeout", { getPings: null, saveStatistic: null });
      dispatch("saveStatistic");
    },
    makePing({ commit, state }) {
      if (!state.start) {
        commit("start");
      }
      let start = performance.now();
      http
        .get("/api/v1/ping/make")
        .finally(() => commit("storePing", performance.now() - start));
    },
    saveStatistic({ commit, state }) {
      if (!state.pings.length) {
        return;
      }

      let format = "YYYY-MM-DD HH:mm:ss";
      http
        .post("api/v1/ping", {
          average: state.pings.reduce((a, b) => a + b) / state.pings.length,
          started_at: state.start.format(format),
          ended_at: moment().format(format)
        })
        .then(() => commit("start"));
    }
  },
  mutations: {
    storePing(state, duration) {
      state.pings.push(duration);
    },
    start(state) {
      state.start = moment();
      state.pings = [];
    },
    setTimeout(state, timeouts) {
      state.timeouts = timeouts;
    }
  },
  getters: {
    all({ pings }) {
      return pings;
    }
  }
};

export default ping;
